<template>
  <div class="question-module">
    <component
      v-bind:is="currentComponent"
      :answer="answerItem"
      :data="itemInfo"
      :userFieldInfo="userFieldInfo"
      @judgeRule="judgeRule"/>
  </div>
</template>
<script>
import VueTypes from 'vue-types'

import typeLists from '../../config/eventType'

export default {
  name: 'question-module',
  props: {
    itemInfo: VueTypes.object,
    answersWriting: VueTypes.array,
    userFieldInfo: VueTypes.object.def({})
  },
  components: {
  },
  data () {
    return {
      answerItem: {}
    }
  },
  created () {
  },
  computed: {
    currentComponent () {
      return typeLists.formTypeList[this.itemInfo.type]
    }
  },
  methods: {
    judgeRule (qInfo) {
      this.$emit('judgeRule', qInfo)
    }
  }
}
</script>
<style lang="scss" scoped>
.question-module {
  margin-bottom: 36px;
}
</style>
